import React from 'react';
import Section from '../../../../components/Display/Section';
import Data from '../../../../components/Display/Data';
import moment from 'moment';
import MultiLineData from '../../../../components/Display/MultiLineData';
import { confirmDialog } from 'primereact/confirmdialog';
import { Button } from 'primereact/button';

import MultipleDataTag from '../../../../components/Display/MultipleDataTag';
import DataTag from '../../../../components/Display/DataTag';
import { getConstant } from '../../../../utils/constants';
import styles from "../../../../components/Display/Wrapper.module.scss";

function EventDetail({ event, handleUpdateEvent, handleDelete }) {
  const updateEventActions = [
    {
      onClick: handleUpdateEvent,
      label: 'Modifier les informations',
      icon: 'pi-pencil'
    }
  ];

  const confirmDeletion = (event) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer cet Évènement ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      acceptClassName: 'bg-red-500 border-red-500',
      accept: () => handleDelete(event)
    });
  };

  return (
    <div className={styles.scrollableSectionContainer}>
      <Section label="Informations Générales" actions={updateEventActions}>
        <div className="flex flex-wrap gap-5">
          <Data key="title" label={'Titre'} value={event.title} large />
          <Data
            key="start_dt"
            label={'Date de début'}
            value={moment(event.start_dt).format('LLL')}
            large
          />
          <Data
            key="end_dt"
            label={'Date de fin'}
            value={moment(event.end_dt).format('LLL')}
            large
          />

          <Data key="place" label={'Lieu'} value={event.place} large />
          <DataTag
            key="format"
            label={'Format'}
            tag={{
              label: getConstant('solarys.formatList', event.format).label,
              icon: 'shape',
              bgColor: 'bg-blue-500'
            }}
          />
          <Data key="src_url" label={'Lien url'} value={event.src_url} large />

          <div className="flex flex-wrap gap-5">
            <MultipleDataTag
              key="publilc_list"
              label={'Public Cible'}
              tags={event.public_list.map((ot) => ({
                label: ot.label,
                bgColor: 'bg-yellow-500',
                icon: 'man'
              }))}
            />
          </div>
        </div>

        <div className="flex flex-wrap gap-5">
          <MultiLineData
            key="description"
            label={'Description'}
            value={event.content}
            large
            asHtml
          />
        </div>
      </Section>

      <Section label="Autres actions">
        <div className="flex flex-row">
          <Button
            key={'delete'}
            label={"Supprimer l'évènement"}
            className="!w-54"
            outlined
            onClick={() => confirmDeletion(event)}
            severity="danger"
          />
        </div>
      </Section>
    </div>
  );
}

export default EventDetail;
